<template>
  <f7-page>
    <f7-navbar :title="$t('label.spendingCategories')" :back-link="$t('action.back')">
      <f7-nav-right>
        <f7-link v-if="categories.length > 1" @click="sort(null)">{{editAction}}</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-list v-for="mainCat in categories" :key="mainCat.id" v-if="!sortingEnabled">
      <f7-list-item>
        <f7-link v-if="mainCat.editable" slot="media" @click="rename(mainCat)">
          <f7-icon f7="square_pencil_fill" color="blue"/>
        </f7-link>
        <strong slot="title">{{mainCat.name}}</strong>
        <f7-link v-if="mainCat.categories.length > 1" slot="after" @click="sort(mainCat)">{{editAction}}</f7-link>
        <f7-link v-else-if="mainCat.categories.length === 0" slot="after" @click="deleteMainCat(mainCat)">
          <f7-icon f7="xmark_circle_fill" color="pink"/>
        </f7-link>
      </f7-list-item>
      <f7-list-item v-for="subCat in mainCat.categories" :key="subCat.id" :title="subCat.name">
        <f7-link v-if="subCat.editable" slot="media" @click="rename(subCat)">
          <f7-icon f7="square_pencil" color="blue"/>
        </f7-link>
        <f7-link slot="after" @click="deleteSubCat(mainCat, subCat)">
          <f7-icon f7="xmark_circle_fill" color="pink"/>
        </f7-link>
      </f7-list-item>
      <f7-list-item>
        <i slot="title" class="grey">Add new subcategory</i>
        <f7-link slot="after" @click="addSubCat(mainCat)">
          <f7-icon f7="plus_circle_fill" color="blue"/>
        </f7-link>
      </f7-list-item>
    </f7-list>
    <f7-list v-if="!sortingEnabled">
      <f7-list-item>
        <i slot="title" class="grey"><strong>Add new main category</strong></i>
        <f7-link slot="after" @click="addMainCat()">
          <f7-icon f7="plus_circle_fill" color="blue"/>
        </f7-link>
      </f7-list-item>
    </f7-list>
    <f7-list v-if="isMainSorting" sortable sortable-enabled @sortable:sort="onMainSort($event)">
      <f7-list-item v-for="mainCat in categories" :key="mainCat.id"><strong slot="title">{{mainCat.name}}</strong>
      </f7-list-item>
    </f7-list>
    <f7-list v-if="isSubSorting" sortable sortable-enabled @sortable:sort="onSubSort($event)">
      <f7-list-item v-for="subCat in currentMainCat.categories" :key="subCat.id">{{subCat.name}}</f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'

  export default {
    name: 'categories-page',
    computed: {
      editAction () {
        return this.sortingEnabled ? 'Done' : 'Sort'
      },
      isMainSorting () {
        return this.sortingEnabled && this.currentMainCat === null
      },
      isSubSorting () {
        return this.sortingEnabled && this.currentMainCat !== null
      }
    },
    data () {
      return {
        sortingEnabled: false,
        currentMainCat: null
      }
    },
    async created () {
      await this.$store.dispatch('fetchCategories')
    },
    methods: {
      addMainCat () {
        this.$f7.dialog.prompt('Please enter a name for the new main category', '', async (name) => {
          const categoryId = await api.createCategory ({name: name})
          this.categories.push({
            id: categoryId,
            name: name,
            editable: true,
            categories: []
          })
          await api.updateCategories(this.categories)
        })
      },
      addSubCat (mainCat) {
        this.$f7.dialog.prompt(`Please enter a name for the new subcategory of "${mainCat.name}"`, '', async (name) => {
          const categoryId = await api.createCategory ({name: name})
          mainCat.categories.push({
            id: categoryId,
            name: name,
            editable: true
          })
          await api.updateCategories(this.categories)
        })
      },
      deleteMainCat (mainCat) {
        this.$f7.dialog.confirm(`Are you sure, you want to delete category "${mainCat.name}"?`, '', async () => {
          const index = this.categories.indexOf(mainCat)
          this.$delete(this.categories, index)
          await api.updateCategories(this.categories)
        })
      },
      deleteSubCat (mainCat, subCat) {
        this.$f7.dialog.confirm(`Are you sure, you want to delete category "${subCat.name}"?`, '', async () => {
          const index = mainCat.categories.indexOf(subCat)
          this.$delete(mainCat.categories, index)
          await api.updateCategories(this.categories)
        })
      },
      async onMainSort (e) {
        this.categories.splice(e.detail.to, 0, this.categories.splice(e.detail.from, 1)[0])
        await api.updateCategories(this.categories)
      },
      async onSubSort (e) {
        this.currentMainCat.categories.splice(e.detail.to, 0, this.currentMainCat.categories.splice(e.detail.from, 1)[0])
        await api.updateCategories(this.categories)
      },
      rename (cat) {
        this.$f7.dialog.prompt('Change the name', '', async (name) => {
          cat.name = name
          await api.updateCategory(cat)
        }, null, cat.name)
      },
      sort (mainCat) {
        this.sortingEnabled = !this.sortingEnabled
        this.currentMainCat = mainCat
      }
    },
    mixins: [helpers]
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .grey {
    color: $med-grey;
  }
</style>
